var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'deadline-notice-list',
  created () {
    this.search(false)
  },
  data () {
    return {
      searchCallbackFlag: false
    }
  },
  computed: {
    notices () {
      return this.$store.getters.notices
    },
    // 本人から提出済みの更新書類（P12）
    submittedRenewals () {
      return this.$store.getters.documentRenewals
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    },
    isClerk () {
      return this.$store.getters.clerk
    },
    canReview () {
      return this.isShopMaster || this.isClerk || this.isSystemManagement
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      var data = {'user_id': window.localStorage.getItem('user_id')}
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      this.$store.dispatch('GET_NOTICE', {data: data, callback: callback} )
      if (this.canReview) {
        this.$store.dispatch('GET_DOCUMENT_RENEWALS', {data: {'status': 'submitted'}})
      }
    },
    // お知らせに対応する提出済みの更新書類を返す
    submittedRenewal: function (notice) {
      if (!this.submittedRenewals) return null
      var userId = notice.attributes['user-id']
      var documentType = notice.attributes['target-deadline']
      for (var i = 0; i < this.submittedRenewals.length; i++) {
        var renewal = this.submittedRenewals[i]
        if (renewal.attributes['user-id'] === userId && renewal.attributes['document-type'] === documentType) {
          return renewal
        }
      }
      return null
    },
    goDocumentRenewal: function (id) {
      window.sessionStorage.setItem('BackPage', '/deadline_notices')
      this.$router.push({ path: '/document_renewals/' + id })
    },
    goUserPdf: function(userId) {
      window.sessionStorage.setItem('BackPage', '/deadline_notices')
      this.$router.push({ path: '/users/' + userId + '/pdf'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/deadline-notice-list.js